import { render, staticRenderFns } from "./DepositStatusView.vue?vue&type=template&id=75ec239a&scoped=true&"
import script from "./DepositStatusView.vue?vue&type=script&lang=ts&"
export * from "./DepositStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ec239a",
  null
  
)

export default component.exports